/* Jayone PLP — sort select + quick-filter chips (ADR 0033 decisions 1–2).
 *
 * Markup: sections/section-jayone-products-filter-grid.liquid ([data-plp]).
 *
 * Sort    Native Shopify ?sort_by= — the select navigates; other query params
 *         (e.g. ?filter.p.vendor=) are kept when the form posts to the same
 *         path, ?page= is dropped (a new order starts on page 1), and the chip
 *         state in the hash survives the reload. A form with data-featured-url
 *         (the sorted all-products view) returns there on "Featured".
 * Chips   Client-side filter over the tiles already on the page. The section
 *         only renders chips when the WHOLE list is on one page, so the count
 *         never lies. Chips in one group (storage, origin) are OR-ed; groups are
 *         AND-ed. Each chip shows how many tiles it would leave given the other
 *         groups' choices; a chip that would leave none is disabled. State lives
 *         in the URL hash (#filter=a,b) with one history entry per change, so
 *         back / forward step through filter states.
 *
 * No framework, no dependencies; every selector is a data-* hook so styling
 * classes can change freely.
 */
(function () {
  'use strict';

  function initSort(root) {
    var form = root.querySelector('[data-plp-sort]');
    if (!form) return;
    var select = form.querySelector('[data-plp-sort-select]');
    if (!select) return;
    // The sorted all-products view (/collections/all-jayone) goes back to its
    // home, /pages/products, when "Featured" is chosen again (data-featured-url).
    var featuredUrl = form.getAttribute('data-featured-url');
    select.addEventListener('change', function () {
      if (featuredUrl && select.value === form.getAttribute('data-default')) {
        window.location.assign(featuredUrl + window.location.hash);
        return;
      }
      var target;
      try {
        target = new URL(form.getAttribute('action') || window.location.pathname, window.location.href);
      } catch (e) {
        form.submit();
        return;
      }
      var params = target.pathname === window.location.pathname
        ? new URLSearchParams(window.location.search)
        : new URLSearchParams();
      if (select.value && select.value !== form.getAttribute('data-default')) {
        params.set('sort_by', select.value);
      } else {
        params.delete('sort_by');
      }
      params.delete('page');
      var qs = params.toString();
      window.location.assign(target.pathname + (qs ? '?' + qs : '') + window.location.hash);
    });
  }

  function initChips(root) {
    var box = root.querySelector('[data-plp-chips]');
    var grid = root.querySelector('[data-plp-grid]');
    if (!box || !grid) return;

    var chips = Array.prototype.slice.call(box.querySelectorAll('[data-qf-token]'));
    if (!chips.length) return;
    var clearBtn = box.querySelector('[data-qf-clear]');
    var countEl = root.querySelector('[data-plp-count]');
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-qf]')).map(function (el) {
      return { el: el, toks: ' ' + (el.getAttribute('data-qf') || '').trim() + ' ' };
    });
    var total = tiles.length;
    var known = {};
    chips.forEach(function (c) { known[c.getAttribute('data-qf-token')] = c.getAttribute('data-qf-group'); });
    var sel = {};

    function readHash() {
      var out = {};
      var m = window.location.hash.match(/(?:^#|&)filter=([^&]*)/);
      if (!m) return out;
      decodeURIComponent(m[1]).split(',').forEach(function (t) {
        if (known[t]) out[t] = true;
      });
      return out;
    }

    function byGroup(skipGroup) {
      var g = {};
      Object.keys(sel).forEach(function (t) {
        var grp = known[t];
        if (grp === skipGroup) return;
        (g[grp] = g[grp] || []).push(t);
      });
      return g;
    }

    function matches(tile, groups) {
      for (var grp in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, grp)) continue;
        var ok = false;
        for (var i = 0; i < groups[grp].length; i++) {
          if (tile.toks.indexOf(' ' + groups[grp][i] + ' ') !== -1) { ok = true; break; }
        }
        if (!ok) return false;
      }
      return true;
    }

    function label(n) { return n + (n === 1 ? ' product' : ' products'); }

    function apply() {
      var all = byGroup(null);
      var visible = 0;
      tiles.forEach(function (t) {
        var show = matches(t, all);
        t.el.hidden = !show;
        if (show) visible++;
      });
      chips.forEach(function (c) {
        var tok = c.getAttribute('data-qf-token');
        var others = byGroup(known[tok]);
        var n = 0;
        tiles.forEach(function (t) {
          if (t.toks.indexOf(' ' + tok + ' ') !== -1 && matches(t, others)) n++;
        });
        var cnt = c.querySelector('[data-qf-count]');
        if (cnt) cnt.textContent = n;
        var unit = c.querySelector('[data-qf-unit]');   // screen-reader suffix: "1 product" / "5 products"
        if (unit) unit.textContent = n === 1 ? ' product' : ' products';
        var on = !!sel[tok];
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!on && n === 0) c.setAttribute('aria-disabled', 'true');
        else c.removeAttribute('aria-disabled');
      });
      var any = Object.keys(sel).length > 0;
      if (clearBtn) clearBtn.hidden = !any;
      if (countEl) countEl.textContent = any ? visible + ' of ' + label(total) : label(total);
    }

    function writeHash() {
      var toks = chips.map(function (c) { return c.getAttribute('data-qf-token'); })
                      .filter(function (t) { return sel[t]; });
      var url = window.location.pathname + window.location.search + (toks.length ? '#filter=' + toks.join(',') : '');
      try { window.history.pushState({ jayonePlp: 1 }, '', url); } catch (e) { /* file:// or sandbox — state still applies */ }
    }

    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-qf-token]');
      if (chip && box.contains(chip)) {
        if (chip.getAttribute('aria-disabled') === 'true') return;
        var tok = chip.getAttribute('data-qf-token');
        if (sel[tok]) delete sel[tok]; else sel[tok] = true;
        writeHash();
        apply();
        return;
      }
      if (e.target.closest('[data-qf-clear]')) {
        sel = {};
        writeHash();
        apply();
        chips[0].focus();
      }
    });

    function fromUrl() { sel = readHash(); apply(); }
    window.addEventListener('popstate', fromUrl);
    window.addEventListener('hashchange', fromUrl);

    sel = readHash();
    if (Object.keys(sel).length) apply();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-plp]'), function (root) {
      initSort(root);
      initChips(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
